
import {defineComponent} from "vue";
import SectionDivisor from "./SectionDivisor.vue";

export default defineComponent({
  components: { SectionDivisor },
  data() {
    return {
      missions: [
        {
          title: "Corporativa",
          description:
            "Guardiã do DNA lince, responsável pela cultura organizacional, conteúdos institucionais e sustentabilidade, com atenção às pessoas da empresa e da comunidade.",
          image: "corporativa-icon.png",
        },
        {
          title: "Operações",
          description:
            "Escola responsável por capacitar tecnicamente os colaboradores, conforme o core business de cada uma das empresas do grupo.",
          image: "operacoes-icon.png",
        },
        {
          title: "Administração",
          description:
            "Capacitar profissionais através de trilhas de conhecimentos técnicos nas áreas administrativas garantindo a alta performance dos profissionais nas rotinas e projetos que atuam.",
          image: "administracao-icon.png",
        },
        {
          title: "Gestão e liderança",
          description:
            "Desenvolver profissionais nas competências e habilidades de gestão e liderança, com visão estratégia e sistêmica comprometidos com o crescimento e desenvolvimento do grupo.",
          image: "lideranca-icon.png",
        },
        {
          title: "Mercado",
          description:
            "Com foco nas áreas de marketing e comercial a escola de mercado desenvolverá os colaboradores nas estratégias de vendas posicionamento de marca e produtos do grupo lince.",
          image: "mercado-icon.png",
        },
        {
          title: "Ferramentas",
          description:
            "Apoiar todas as demais escolas, fornecendo conteúdos de suporte para o desenvolvimento das atividades.",
          image: "ferramentas.svg",
        },
      ],
    };
  },
});
